import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DotsMobileStepper from './dots-stepper';
import { Box } from '@mui/material';

export default function ScrollDialog({open, handleClose, images, active, handleNext, handleBack}) {

    const img = images[active]

    const [touchStart, setTouchStart] = React.useState(null)
    const [touchEnd, setTouchEnd] = React.useState(null)

    // the required distance between touchStart and touchEnd to be detected as a swipe
    const minSwipeDistance = 50 

    const onTouchStart = (e) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe || isRightSwipe) console.log('swipe', isLeftSwipe ? 'left' : 'right')
        // add your conditional logic here
        if(isLeftSwipe){
            handleNext()
        }
        if(isRightSwipe){
            handleBack()
        }
    }

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        maxWidth="lg"
      >
        <DialogTitle id="scroll-dialog-title">Galería de imágenes</DialogTitle>
        <DialogContent>
            {(window.innerWidth > 600) ?
                <DotsMobileStepper
                    activeStep={active}
                    nSteps={images.length}
                    handleNext={handleNext}
                    handleBack={handleBack}
                />
                :
                null
            }
            <Box onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                <img
                    width='100%'
                    height='auto'
                    srcSet={`${img?.img}?fit=crop&auto=format&dpr=2 2x`}
                    src={`${img?.img}`}
                    alt={img?.title}
                    loading="lazy"
                />
            </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
  );
}